import { version as currVersion } from './version';

export const CheckVersion = async () => {
  try {
    const response = await fetch('/version.json', { cache: 'no-store' });
    const data = await response.json();

    if (data.version !== currVersion) {
      alert('The site has been updated to a newer version. A reload is required');
      window.location.reload();
    }
  } catch (error) {
    console.log('Error occured while version checking', error);
  }
};
